import { Divider } from "primereact/divider";
import React from "react";
import { formatDate } from "../config/Config";

const ViewDetails = ({documentDetails,

}) => {

    console.log(documentDetails)
	return (
		<div>
			<Divider align="center">
				<h5 class="">Document details</h5>
			</Divider>
			<div className="grid card mt-2 mx-1">
				<div class="col-12">
					<div class="row flex">
						<div class="text-left col-6 font-bold">Document Name :</div>
						<div class="col-6 text-start"> {documentDetails.title}</div>
					</div>
					<div class="row flex">
						<div class="text-left col-6 font-bold">Document Type :</div>
						<div class="col-6 text-start"> {documentDetails.documentType}</div>
					</div>
					<div class="row flex">
						<div class="text-left col-6 font-bold">Date Created :</div>
						<div class="col-6 text-start"> {formatDate(documentDetails.createdDate)}</div>
					</div>
					<div class="row flex">
						<div class="col-6 text-left font-bold">Created By :</div>
						<div class="col-6 text-start">{documentDetails.createdByInternal}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ViewDetails;
